import { use } from 'react';
import { loadReportsDependencies } from 'AssetLoader';

let reportsDependenciesPromise: Promise<void> | null = null;

function getGlobalReportsDependenciesPromise(): Promise<void> {
    if (!reportsDependenciesPromise) {
        reportsDependenciesPromise = loadReportsDependencies();
    }
    return reportsDependenciesPromise;
}

/**
 * Suspense-enabled hook to load reports dependencies using React 19's `use` hook.
 * Pure JavaScript implementation without Angular dependencies.
 *
 * This hook will suspend (throw a promise) while dependencies are loading,
 * which requires the component to be wrapped in a <Suspense> boundary.
 *
 * Note: This hook only handles asset loading, not permission checking.
 * Permission checking should be done at the route level via ProtectedRoute.
 *
 * @throws {Promise<void>} When dependencies are still loading (suspends)
 * @throws {Error} When dependency loading fails
 */
export function useLoadReportsDependencies(): void {
    // React 19's `use` hook handles the suspense automatically
    use(getGlobalReportsDependenciesPromise());
}
